import { IsOptional, IsArray, IsString } from 'class-validator';

export class EditAccountUserGroupsFormDto {
  @IsArray({ groups: ['form'] })
  @IsString({ each: true, groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  groups?: string[];
}
